import { Link as MuiLink } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
export const LinkStyled = styled(MuiLink, shouldNotForwardProps('fontWeight', 'color'))(({ theme, fontWeight, color }) => ({
    color: theme.palette.primary.dark,
    ...(color && {
        color: color === 'inherit' ? 'inherit' : theme.palette.text[color],
    }),
    ...(fontWeight && {
        fontWeight: fontWeight === 'light'
            ? theme.typography.fontWeightLight
            : fontWeight === 'regular'
                ? theme.typography.fontWeightRegular
                : fontWeight === 'medium'
                    ? theme.typography.fontWeightMedium
                    : fontWeight === 'bold'
                        ? theme.typography.fontWeightBold
                        : 'inherit',
    }),
}));
